import { render } from "./SeleccionPerfil.vue?vue&type=template&id=d6937b44&scoped=true"
import script from "./SeleccionPerfil.vue?vue&type=script&lang=js"
export * from "./SeleccionPerfil.vue?vue&type=script&lang=js"

import "./SeleccionPerfil.vue?vue&type=style&index=0&id=d6937b44&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6937b44"]])

export default __exports__